import { openModal } from '@members/modal';
import type { Source } from '@members/stacks';

const NOTIFICATIONS_MODAL_NAME = 'notificationsFromNav';
export const openNotificationsFromNav = (source: Source) =>
  openModal(NOTIFICATIONS_MODAL_NAME, source);
